import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AgentManagement from '../components/AgentManagement';
import BookingsList from '../components/BookingsList';
import LinkGenerator from '../components/LinkGenerator';
import FormManagement from '../components/FormManagement';
import { authService } from '../services/authService';

function AdminPage() {
  const [activeTab, setActiveTab] = useState('agents');
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate('/admin/login');
  };

  const tabs = [
    { id: 'agents', label: 'Agents', icon: '👥' },
    { id: 'bookings', label: 'Bookings', icon: '📅' },
    { id: 'links', label: 'Generate Links', icon: '🔗' },
    { id: 'forms', label: 'Forms', icon: '📋' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold text-gray-900">Admin Portal</h1>
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
              >
                ← Back to Home
              </Link>
              <button
                onClick={handleLogout}
                className="text-red-600 hover:text-red-700 font-medium transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                  ${activeTab === tab.id
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="mt-8 pb-12">
          {activeTab === 'agents' && <AgentManagement />}
          {activeTab === 'bookings' && <BookingsList />}
          {activeTab === 'links' && <LinkGenerator />}
          {activeTab === 'forms' && <FormManagement />}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
